import { FC, JSX } from "react";
import { ChatServerButton, ChatServerCard } from "../../xapp/ChatServerMessage";
import { ChatActionButtons } from "../ChatActionButtons";
import { ChatImage } from "../ChatImage";
import "./ChatCard.scss";

export interface Props {
    readonly card: ChatServerCard;
    onButtonClick(button: ChatServerButton): void;
}

const ChatCard: FC<Props> = (props) => {
    const card = props.card;

    let title;
    let image: JSX.Element;
    let content;

    if (card.imageUrl) {
        image = (
            <div className="chat-card-container__img">
                <ChatImage imageUrl={card.imageUrl} imageActionUrl={card.imageActionUrl} />
            </div>
        );
    }

    if (card.title) {
        title = (
            <div className="chat-card-title">
                <span>{card.title}</span>
            </div>
        );
    }

    if (card.content) {
        content = (
            <div className="chat-card-sub-title">
                <span>{card.content}</span>
            </div>
        );
    }

    return (
        <div className="chat-card-container">
            {image}
            {title}
            {content}
            {!!card.buttons?.length && (
                <ChatActionButtons buttons={card.buttons} onClick={props.onButtonClick} />
            )}
        </div>
    );
};

export default ChatCard;
